import { inject } from '@angular/core';
import {
  elementRenameUiEvents,
  hyperlinkUiEvents,
} from '@bizzdesign/modeler/utils-canvazz/events';
import {
  objectAPIEvents,
  relationAPIEvents,
} from '@bizzdesign/shared/dom-models';
import { type ProductEvents } from '@bizzdesign/shared/models';
import { ProductAnalyticsService } from '@bizzdesign/shared/services';
import { signalStoreFeature } from '@ngrx/signals';
import { Events, withEventHandlers } from '@ngrx/signals/events';
import { tap } from 'rxjs';
import { sendAnalyticsEvent } from './analytics-effects.utils';

// NOTE: this can be later moved to be a shared signalStore feature
// for simplicity since modeler domain is the only one using ngrx signals, it resides here
export function withElementAnalyticsEffect() {
  return signalStoreFeature(
    withEventHandlers(() => {
      const events = inject(Events);
      const analyticsService = inject(ProductAnalyticsService);

      const sendObjectAnalyticsEvent = (
        eventName: ProductEvents,
        payload?: Record<string, unknown>,
      ) => {
        sendAnalyticsEvent(analyticsService, eventName, payload);
      };

      return {
        deleteObjectFromAPI$: events
          .on(objectAPIEvents.deleteObjectFromAPI)
          .pipe(
            tap(({ payload: { context, frame_id, location, object_type } }) =>
              sendObjectAnalyticsEvent('object_deleted', {
                context,
                frame_id,
                object_type,
                location,
              }),
            ),
          ),
        deleteRelationFromAPI$: events
          .on(relationAPIEvents.deleteRelationFromAPI)
          .pipe(
            tap(
              ({
                payload: {
                  context,
                  frame_id,
                  location,
                  relation_type,
                  object_types,
                },
              }) =>
                sendObjectAnalyticsEvent('relation_deleted', {
                  context,
                  frame_id,
                  relation_type,
                  object_types,
                  location,
                }),
            ),
          ),
        elementRenamed$: events.on(elementRenameUiEvents.elementRenamed).pipe(
          tap(({ payload: { elementType, numberOfHyperlinks, textLength } }) =>
            sendObjectAnalyticsEvent('element_renamed', {
              element_type: elementType,
              number_of_hyperlinks: numberOfHyperlinks,
              text_length: textLength,
            }),
          ),
        ),
        hyperlinkOpened$: events.on(hyperlinkUiEvents.hyperlinkOpened).pipe(
          tap(({ payload: { location, originId } }) =>
            sendObjectAnalyticsEvent('hyperlink_opened', {
              origin_id: originId,
              location,
            }),
          ),
        ),
      };
    }),
  );
}
